module.exports = __webpack_public_path__ + "img/windows.55f58752.svg";